import { Box, Button, Grid, IconButton, Menu, MenuItem, Tooltip, Typography } from "@mui/material";
import React, { useState } from "react";
import { WSIcons } from "../../commonFunctions/iIcons";
import WSDateField from "../../Components/DateField/WSDateField";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import WSDataGrid, { IColumns } from "../../Components/DataGrid/WSDataGrid";
import WSSCheckBoxField from "../../Components/CheckBox/WSCheckBox";
import WSTextField from "../../Components/TextBox/WSTextBox";

export const ItemOnHold: React.FC<any> = React.memo((props) => {
  const { register, control } = useForm();
  const navigate = useNavigate();
  
  const handleClick = (path: string) => {
    navigate(path);
  };

  const columns: IColumns[] = [
    {
      header: "Receipt#",
      fieldName: "workLocationName",
      tooltip: true,
    },
    {
      header: "Table/User",
      fieldName: "address",
      tooltip: true,
    },
    {
      header: "Item Name",
      fieldName: "address",
      tooltip: true,
    },
    {
      header: "Order Time",
      fieldName: "address",
      tooltip: true,
    },
    {
      header: "Deliver Time",
      fieldName: "address",
      tooltip: true,
    },
   
  ];
  
  return (
    <Grid 
      display="flex" 
      flexDirection="column" 
      minHeight="100vh" // Ensures the container occupies the full height of the viewport
    >
    <Grid container direction="column" spacing={2} p={2} flex="1">
      {/* Header and Icon Section */}
      <Grid item>
        <Grid container alignItems="center" justifyContent="space-between">
          <Grid item>
            <Typography
              variant="h6"
              sx={{ fontWeight: "bold", color: "green" }}
            >
             Item On Hold
            </Typography>
          </Grid>
          <Grid item>
            <Grid display="flex" alignItems="center">
              <Typography marginRight={"1rem"}>Receipt#</Typography>
            <WSTextField
            label={""}
            {...register("receipt")}
            id="receipt"
            name="receipt"
            control={control}
            rules={{ required: false }}
          />
              <Tooltip title="Refersh">
                <IconButton
                  sx={{
                    border: "1px solid #ccc",
                    padding: "8px",
                    marginRight: "8px",
                    borderRadius: "2px",
                    marginLeft: "16px",
                  }}
                >
                  <WSIcons.SyncIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title="Search">
                <IconButton
                  sx={{
                    border: "1px solid #ccc",
                    padding: "8px",
                    marginRight: "8px",
                    borderRadius: "2px",
                  }}
                >
                  <WSIcons.SearchIcon />
                </IconButton>
              </Tooltip>
              
              <IconButton>
                <WSIcons.CloseIcon
                  sx={{ backgroundColor: "red", color: "white" }}
                  onClick={() => handleClick("/")}
                />
              </IconButton>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      {/* DataGrid Section */}
      <Grid item>
        <WSDataGrid id="itemGrid" title="" columns={columns} />
      </Grid>
      </Grid>
      <Grid bgcolor="#333" p={2} display="flex" justifyContent="space-between">
        <WSIcons.GTranslateIcon/>
        <Button variant="outlined" sx={{borderColor:"green",color:"white"}}>5</Button>
        <Button variant="outlined" sx={{borderColor:"green",color:"white"}}>10</Button>
        <Button variant="outlined" sx={{borderColor:"green",color:"white"}}>15</Button>
        <Button variant="outlined" sx={{borderColor:"green",color:"white"}}>20</Button>
        <Button variant="outlined" sx={{borderColor:"green",color:"white"}}>25</Button>
        <Button variant="outlined" sx={{borderColor:"green",color:"white"}}>30</Button>
        <Button variant="outlined" sx={{borderColor:"green",color:"white"}}>40</Button>
        <Button variant="outlined" sx={{borderColor:"green",color:"white"}}>45</Button>
        <Button variant="outlined" sx={{borderColor:"green",color:"white"}}>50</Button>
        <Button variant="outlined" sx={{borderColor:"green",color:"white"}}>55</Button>
        <Button variant="outlined" sx={{borderColor:"green",color:"white"}}>Manual</Button>
        <Button variant="contained" color="success">Fire</Button>
      </Grid>
    </Grid>
  );
});
